<template>
    <b-card class="block__objectiveListProduction">
      <header>
        <p class="title">{{title}}</p>
      </header>


      <b-list-group>
        <b-list-group-item v-for="(list,index) of lists" :key="index">

          <div class="entete">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>                
              <div class="title">
                  {{list.title}}
                <div class="icon" :class="list.color" v-if="list.icon">
                  <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                </div>
              </div>
            </PuSkeleton>
            <PuSkeleton :loading="isLoading" :count="1" width='20px'>
              <div class="number" v-if="list.number">{{list.number}}</div>
            </PuSkeleton>
          </div>

          <div class="label">

            <div class="left">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                {{list.label}}              
                <span v-if="list.value">{{list.value}}</span>
                <span class="black" v-if="list.valueStrong">{{list.valueStrong}}</span>
              </PuSkeleton>
            </div>

            <div class="result" v-if="list.valueStrongSub">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{list.valueStrongSub}}
              </PuSkeleton>
            </div>

          </div>

          <div v-if="list.label2" class="label">
            
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>
              <div class="left">
                {{list.label2}}              
                <span class="black" v-if="list.valueStrong2">{{list.valueStrong2}}</span>
              </div>
            </PuSkeleton>
            
            <div class="result" v-if="list.valueStrongSub2">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{list.valueStrongSub2}}
              </PuSkeleton>
            </div>            
          
          </div>

        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveListProductions",
  props:{
    title:{
      type:String,
      default:'Bonus'
      },
    objectifNumber:{
      type:Number,
      default:0
      },
    lists:{
      type:Array,
      },
  },
  data(){
    return {
      isLoading:true,
    }
  },
  mounted () {
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>